import React from 'react';
import {Box} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {Campaign} from '@/types/campaign';
import {ProfileProps} from '@/types/creatorProfile';
import CampaignCreatorInfoRow from './CampaignCreatorInfoRow';
import findMatchingIdentity from './utils/findMatchingIdentity';

interface CampaignCreatorInfoProps {
  campaign?: Campaign | null;
  profile?: ProfileProps | null;
}

function CampaignCreatorInfo({campaign, profile}: CampaignCreatorInfoProps) {
  if (!campaign && !profile) {
    return null;
  }

  const matchingIdentity = findMatchingIdentity(
    campaign,
    profile?.identities || []
  );

  const campaignName = campaign?.name;
  const creatorHandle = matchingIdentity?.cachedHandle;

  if (!campaignName && !creatorHandle) {
    return null;
  }

  const rows = [];
  if (campaignName) {
    rows.push({label: 'CAMPAIGN', value: campaignName});
  }
  if (creatorHandle) {
    rows.push({label: 'CREATOR', value: `@${creatorHandle}`});
  }

  return (
    <Box
      sx={{
        border: `1px solid ${designSystemToken('semantic.border.secondary')}`,
        borderRadius: 1,
        backgroundColor: designSystemToken('semantic.bg.primary'),
        overflow: 'hidden',
      }}
    >
      {rows.map((row, index) => (
        <CampaignCreatorInfoRow
          key={row.label}
          label={row.label}
          value={row.value}
          isLast={index === rows.length - 1}
          hasBorder={rows.length > 1}
        />
      ))}
    </Box>
  );
}

export default CampaignCreatorInfo;
